




import { defineComponent } from '@vue/composition-api';

const CommonChip = defineComponent({
  props: {
    color: {
      type: String,
      default: 'gray',
    },
    text: {
      type: String,
    },
    textSize: {
      type: String,
      default: 'sm',
    },
    textColor: {
      type: String,
      default: 'white',
    },
  },
  // setup() {},
});

export default CommonChip;
